var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"pa-6",attrs:{"flat":""}},[_c('aiInfoTable',{attrs:{"aiHeaders":_vm.aiHeaders,"apiUrl":_vm.apiUrl,"editable":_vm.editableAi,"clientId":_vm.$store.state.client,"filters":_vm.filters}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }